import styled from "styled-components";

export const InfoTitle = styled.span`
  display: flex;
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--grayLv3);
  margin-bottom: 5px;

  svg {
    margin-left: 8px;
  }
`;

export const InfoValue = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  text-transform: uppercase;
  color: var(--grayLv3);
  & svg {
    margin-right: 8px;
  }
`;
